import request from '@/utils/request'
import qs from 'qs'
export function getListHotelinkReport(query) {
  return request({
    url: '/report-service/v1/hotellink-report/list',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}
export function getListHotelinkReportExcel(query) {
  return request({
    url: '/report-service/v1/hotellink-report/excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    },
    responseType: 'blob'
  })
}
